// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.59-TSS-3062-mcastro-IMPROVEMENT-Bulk-Download-JSON-Excel-from-AdOps.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
